// @flow
import React from "react";
import { connect } from "react-redux";
import t from "common/i18n";
import ResultImageGrid from "root/components/ResultImageGrid";
import {
	selectContextItems,
	selectSearchSummary,
} from "../../selectors";

import "./ContextItems.scss";

type OwnProps = {|
    inSearch?: boolean,
    isMultiple?: boolean,
    onSelect: Function,
	onLoadMore?: Function,
    isFiltersPanelOpen: boolean,
    context: { context: number },
|};

type Props = {
    ...OwnProps,
    inProgress: boolean,
    items: Object[],
    selected: string[],
    total: number,
    searchSummary: string,
	hasMore?: boolean;
};

export const ContextItems = (props: Props) => {
	const topBarRenderer = () => (props.searchSummary
		? <span className="b">{t("shutterstock.filter_summary.label",
			{ summary: props.searchSummary })}
		</span> : null);

	return <div className={`context-items w-100 h-100 photos-${props.context.context}`}>
		<ResultImageGrid
			images={props.searchSummary ?  props.items : props.items.slice(0, props.isFiltersPanelOpen  ? 3 : 4)}
			selected={props.selected}
			selectionAction={props.onSelect}
			showProgressIndicator={props.inProgress}
			onLoadMore={props.onLoadMore}
			isMultiple={false}
			useImageClientSize
			itemWidth={props.isFiltersPanelOpen ? 170 : null}
			topBarRenderer={props.onLoadMore && topBarRenderer}
			hasMore={props.hasMore}
		/>
	</div>;
};
export default connect<Props, OwnProps, _, _, _, _>((state) => ({
	...selectContextItems(state),
	searchSummary: selectSearchSummary(state),
}),
null)(ContextItems);
